import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import NumberFormat from 'react-number-format';
import { inRange } from 'lodash';
import PropTypes from 'prop-types';

const styles = theme => ({
    card: {
        display: 'flex',
        width: "100%",
        marginBottom:'20px'
      },
  });

  function createData(amountInDispute, fee) {
    return { amountInDispute, fee};
  }

  const feeCalculatorData = [
    createData([0, 1000], '100.00'),
    createData([1001, 2000], '200.00'),
    createData([2001, 5000], '500.00'),
    createData([5001, 10000], '1000.00'),
    createData([10001, 15000], '1500.00'),
    createData([15001, 20000], '2000.00'),
    createData([20001, 50000], '2500.00'),
    createData([50001, 100000], '5000.00'),
    createData([100001, 150000], '7500.00'),
    createData([150001, 250000], '12500.00'),
    createData([250001, null], '25000.00'),
    // createData([50000, 1500000], '37500.00'),
    // createData([150001, 3000000], '75000.00'),
    // createData([300001, 10000000], '125000.00'),
    // createData([10000000, null], '175000.00'),
  ];

  function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
  
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
        thousandSeparator
        //prefix="$"
      />
    );
  }


class FeeCalculator extends Component {
    state= {
        disputeAmount: null,
        fee: 100,
    }

    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
        this.handleFeeCalculator(Number(event.target.value))
    };

    handleFeeCalculator = (disputeAmount) => {
        const data = feeCalculatorData;
        let fee = null;
        if(disputeAmount >= data[data.length - 1].amountInDispute[0]){
            fee = data[data.length - 1].fee;
        }else{
            fee = data.slice(0, data.length - 1).filter((d, i) => inRange(disputeAmount, d.amountInDispute[0], d.amountInDispute[1]) || disputeAmount == d.amountInDispute[1])[0].fee;
        }
        this.setState({fee: fee});
    };
    

    render(){
        const { classes } = this.props;
        return(
            <Card className={classes.card}>
                <CardContent>
                    <Typography variant="h6"  gutterBottom>
                        {this.context.t('Arbitration Fee Calculator')}
                    </Typography>
                </CardContent>
                
                <TextField
                    id="dispute-amount"
                    label={this.context.t('Enter Dispute Amount')}
                    value={this.state.disputeAmount}
                    onChange={this.handleChange('disputeAmount')}
                    InputProps={{style: {fontSize: '14px'}, inputComponent: NumberFormatCustom, startAdornment: <InputAdornment position="start">HK$</InputAdornment>, }}
                    margin="normal"
                    InputLabelProps={{
                      style: {fontSize: '14px'},
                    }}
                />

                <TextField
                    id="fee"
                    //className={classNames(classes.margin, classes.textField)}
                    //variant="outlined"
                    disabled
                    label={this.context.t('Arbitration Fee')}
                    value={this.state.fee}
                    //onChange={this.handleChange('fee')}
                    InputProps={{
                        style: {fontSize: '14px'},
                        inputComponent: NumberFormatCustom,
                        startAdornment: <InputAdornment position="start">HK$</InputAdornment>,
                    }}
                    InputLabelProps={{
                      style: {fontSize: '14px'},
                    }}
                    margin="normal"
                    />
            </Card>
        );
    }
}



export default withStyles(styles)(FeeCalculator);

FeeCalculator.contextTypes = {
    t: PropTypes.func
}